/**
 * Marker utility functions
 * Shared utilities for marker creation across map providers
 */

/**
 * Create a Leaflet icon for a marker
 * Supports both standard image icons and custom divIcons with labels
 *
 * @param {object} options - Marker options
 * @param {string} options.icon - Icon URL
 * @param {number} options.w - Icon width
 * @param {number} options.h - Icon height
 * @param {string} options.label - Label text to display below icon
 * @returns {L.Icon|L.DivIcon}
 */
export function createMarkerIcon(options) {
	// If label is provided, use divIcon with custom HTML
	if (options.label) {
		const iconHtml = options.icon
			? `<div class="map-marker"><div class="position-absolute"><img src="${options.icon}" style="width:${options.w}px;height:${options.h}px;"></div><span class="map-marker-price mt-1">${options.label}</span></div>`
			: `<div class="map-marker"><span class="map-marker-price mt-1">${options.label}</span></div>`;

		return L.divIcon({
			html: iconHtml,
			className: 'map-marker-wrapper',
			iconSize: options.w && options.h ? [parseInt(options.w), parseInt(options.h)] : [25, 41],
			iconAnchor: options.w && options.h ? [parseInt(options.w) / 2, parseInt(options.h)] : [12, 41],
			popupAnchor: [0, -41]
		});
	}
	// Standard image icon (no label)
	else if (options.icon) {

		const iconHtml = `<div class="map-marker"><div class="position-absolute"><img src="${options.icon}" style="width:${options.w}px;height:${options.h}px;"></div></div>`;

		return L.divIcon({
			html: iconHtml,
			className: 'map-marker-wrapper',
			iconSize: options.w && options.h ? [parseInt(options.w), parseInt(options.h)] : [25, 41],
			iconAnchor: options.w && options.h ? [parseInt(options.w) / 2, parseInt(options.h)] : [12, 41],
			popupAnchor: [0, -41]
		});

		// const iconOptions = {
		// 	iconUrl: options.icon,
		// 	iconSize: options.w && options.h ? [parseInt(options.w), parseInt(options.h)] : [25, 41],
		// 	iconAnchor: options.w && options.h ? [parseInt(options.w) / 2, parseInt(options.h)] : [12, 41],
		// 	popupAnchor: [0, -41]
		// };
		//
		// return L.icon(iconOptions);
	}

	return null;
}
